import api from "./api";

// Capa de servicios API del dominio "etiquetas de ticket" (ticket-tags) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// Quita todas las etiquetas de un ticket.
export const deleteTicketTags = (ticketId) => api.delete(`/ticket-tags/${ticketId}`);
// Asigna una etiqueta a un ticket.
export const assignTicketTag = (ticketId, tagId) =>
  api.put(`/ticket-tags/${ticketId}/${tagId}`);
